module.exports = __webpack_public_path__ + "img/agence-08.df3f17e.jpg";